// extracted by mini-css-extract-plugin
export default {"content":"PhonesList_content__weoZZ","list":"PhonesList_list__llfFj","list__item":"PhonesList_list__item__PTQZr","list__button_delete":"PhonesList_list__button_delete__3rq+8"};